import { DynamicFields } from "./dynamicFields"
import { v4 as uuidv4 } from 'uuid';


export const addDocumentDataStroke = (dataRow, offenseWindow, dataHead, filledStack) => {

    return dataRow.map((row, indexRow) => {


        let oneRow = {id: uuidv4()}

        dataHead.map((_, indexColumn) => {

            let elemRow = {[offenseWindow[indexColumn].variable]: ''}

            if (filledStack[DynamicFields.SIGNATURE_FOR_TABLE].includes(indexColumn)) {

                elemRow = {[offenseWindow[indexColumn].variable]: null} 

            } else if (filledStack[DynamicFields.BASE_SELECT].includes(indexColumn)) {

                let choices = {...offenseWindow[indexColumn].content.choices}
                let value = String(row[indexColumn])
                for (const key in choices) {
                    if (value === choices[key].value) {
                        elemRow = {[offenseWindow[indexColumn].variable]: value} 
                    } 
                }

            } else if (
                    filledStack[DynamicFields.DATE_TIME_SELECT].includes(indexColumn) ||
                    filledStack[DynamicFields.TABLE_DATE_TIME].includes(indexColumn) 
                    ) {

                let date = new Date((Number(row[indexColumn])-25569-(3/24))*3600*24*1000)
                let newFormat = date.toLocaleString()
                elemRow = {[offenseWindow[indexColumn].variable]: newFormat} 

            }   else if (
                    filledStack[DynamicFields.TABLE_DATE].includes(indexColumn) 
                ) {

                if (typeof row[indexColumn] === "number") {
                    let date = new Date((Number(row[indexColumn])-25569-(3/24))*3600*24*1000)
                    let newFormat = date.toLocaleDateString()
                    elemRow = {[offenseWindow[indexColumn].variable]: newFormat}  
                }

                if (typeof row[indexColumn] === "string") {
                    const parts = row[indexColumn].split(".");
                    const date = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
                    let newFormat = date.toLocaleDateString()
                    elemRow = {[offenseWindow[indexColumn].variable]: newFormat}  
                }


            }   else if (
                filledStack[DynamicFields.TABLE_TIME].includes(indexColumn) 
            ) {
                let date = new Date((Number(row[indexColumn])-(3/24))*3600*24*1000)
                let newFormat = date.toLocaleTimeString()
                elemRow = {[offenseWindow[indexColumn].variable]: newFormat} 

            }   else 
            {
                elemRow = {[offenseWindow[indexColumn].variable]: row[indexColumn] !== undefined ? String(row[indexColumn]) : ''}   
            }

            oneRow = {...oneRow, ...elemRow}
        })
        return oneRow
    })
}


export const addDocumentDataColumn = (offenseWindow) => {
    return offenseWindow.map((item) => {
        return {
                field: item.variable,
                headerName: item.label,
                width: 140,
                editable: true,
                headerAlign: 'center',
                align: 'center',
            }
    })
}

export const idColumn = () => {
    return [{
        field: 'id',
        headerName: 'id',
        width: 100,
        editable: false,
        headerAlign: 'center',
        align: 'center',
    }]
}